import { render, staticRenderFns } from "./OrderReturnsList.vue?vue&type=template&id=581822bc&scoped=true&"
import script from "./OrderReturnsList.vue?vue&type=script&lang=js&"
export * from "./OrderReturnsList.vue?vue&type=script&lang=js&"
import style0 from "./OrderReturnsList.vue?vue&type=style&index=0&id=581822bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581822bc",
  null
  
)

export default component.exports